import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=469bad1d&scoped=true"
import script from "./Decline.vue?vue&type=script&lang=js"
export * from "./Decline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bad1d",
  null
  
)

export default component.exports